import { render } from "./AudioPage.vue?vue&type=template&id=210a9ef0&scoped=true"
import script from "./AudioPage.vue?vue&type=script&lang=js"
export * from "./AudioPage.vue?vue&type=script&lang=js"

import "./AudioPage.vue?vue&type=style&index=0&id=210a9ef0&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210a9ef0"]])

export default __exports__